import { AppInterface, AppType } from "@swivl-mono/types";
import { Button, ButtonColor, Input, Panel } from "@swivl-mono/ui";
import { useMemo } from "react";
import { useNavigate } from "react-router-dom";

import AppsModel from "../../../Models/Apps/Apps.Model";
import FBMView from "./FBM/FBMView";
import GoogleAppView from "./Google/Google.AppView";
import MandrillAppView from "./Mandrill/Mandrill.AppView";
import TwilioView from "./Twilio/TwilioView";
import WhatsAppView from "./WhatsApp/WhatsAppView";

interface Props {
  type?: AppType;
  appId?: string;
}

function imageForAppType(type: AppType) {
  switch (type) {
    case AppType.GOOGLE:
      return "https://swivl-cdn.s3-us-west-1.amazonaws.com/app-google.png";
    case AppType.HUBSPOT:
      return "https://swivl-cdn.s3-us-west-1.amazonaws.com/hubspotlogo-web-color.png";

    case AppType.MANDRILL:
      return "https://swivl-cdn.s3-us-west-1.amazonaws.com/app-mandrill.png";
    // case AppType.SLACK:
    //   return "https://swivl-cdn.s3-us-west-1.amazonaws.com/Slack_RGB.png";
    case AppType.TWILIO:
      return "https://swivl-cdn.s3-us-west-1.amazonaws.com/twilio-logo-red.png";
    case AppType.FACEBOOK_MESSENGER:
      return "https://swivl-cdn.s3-us-west-1.amazonaws.com/app-fbmessenger.png";
    case AppType.WHATSAPP:
      return "https://swivl-cdn.s3-us-west-1.amazonaws.com/app-whatsapp.png";
    default:
      return "";
  }
}

function appContentForType(app: AppInterface, selected: boolean) {
  switch (app.type) {
    case AppType.GOOGLE:
      return <GoogleAppView app={app} selected={selected} />;
    case AppType.HUBSPOT:
      return <div>Hubspot Content</div>;

    case AppType.MANDRILL:
      return <MandrillAppView app={app} selected={selected} />;
    // case AppType.SLACK:
    //   return <div>Slack Content</div>;
    case AppType.TWILIO:
      return <TwilioView app={app} selected={selected} />;
    // case AppType.FACEBOOK_MESSENGER:
    //   return <FBMView app={app} selected={selected} />;
    case AppType.WHATSAPP:
      return <WhatsAppView app={app} selected={selected} />;
    default:
      return "";
  }
}
export function AppsDetailsView({ type, appId }: Props) {
  const { apps } = AppsModel.useState();
  const navigate = useNavigate();
  if (!type) {
    return <div>Invalid App Type</div>;
  }
  const appsOfType = useMemo(() => {
    if (!apps) {
      return undefined;
    }
    return apps.filter((app) => app.type === type).filter((app) => app.active);
  }, [apps, type]);
  const selectedAppId = appId ? parseInt(appId) : undefined;

  return (
    <div className="flex flex-col p-5">
      <div className="flex justify-between items-center">
        <img src={imageForAppType(type)} />
        <Button
          onClickAsync={async () => {
            const app = await AppsModel.createApp(type);
            navigate(`/settings/apps/${type}/${app.id}`);
          }}
        >
          + Add Instance
        </Button>
      </div>

      <div className="flex flex-col mt-5">
        {appsOfType?.map((app) => {
          const selected = selectedAppId && app.id === selectedAppId ? true : false;

          return (
            <Panel
              key={app.id}
              open={selected}
              onToggle={() => {
                if (selected) {
                  navigate(`/settings/apps/${type}`);
                } else {
                  navigate(`/settings/apps/${type}/${app.id}`);
                }
              }}
              header={<h4 className="m-0">{app.name}</h4>}
            >
              <div className="flex flex-col">
                <div className="mb-3">
                  <label>Name</label>
                  <Input
                    value={app.name}
                    onChange={(e) => {
                      app.name = e.target.value;
                      AppsModel.update(app, false);
                    }}
                  />
                </div>
                <div className="flex gap-2">
                  {appContentForType(app, selected)}
                  <Button
                    color={ButtonColor.WHITE}
                    onClick={() => {
                      if (window.confirm("Are you sure you want to delete this app?")) {
                        AppsModel.deactivateApp(app);
                        navigate(`/settings/apps/${type}`);
                      }
                    }}
                  >
                    Remove Instance
                  </Button>
                </div>
              </div>
            </Panel>
          );
        })}
      </div>
    </div>
  );
}
